module.exports = __webpack_public_path__ + "img/source3_10.870ace97.png";